import { Button, styled } from "@mui/material";

export const ZoomButtonsWrapper = styled(Button)({
  height: "88px",
  minWidth: "48px",
  background: "#fff",
  borderRadius: "16px",
  padding: "0",
  boxShadow: "0px 1px 8px -1px rgba(0, 0, 0, 0.2)",

  position: "absolute",
  top: "40%",
  right: "24px",
  zIndex: "11",

  display: "flex",
  flexDirection: "column",
});

export const MapButton = styled(Button)({
  height: "40px",
  width: "40px",
  minWidth: "30px",
  padding: 0,
  backgroundColor: "#fff",
  color: "#000",
  cursor: "pointer",
  ":hover": {
    backgroundColor: "#fff",
  },
});
